import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FotaBatchDetailsComponent } from './fota-batch-details.component';

const routes: Routes = [
  {
    path: 'fota-batch-details',
    component: FotaBatchDetailsComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FotaBatchDetailsRoutingModule {}
